import React, {Component} from 'react';
import {Button, Col, Glyphicon, Row} from 'react-bootstrap';
import {handleTypeheadSearch, TypeheadField} from "./form";
import {createPartyOption, resolveApiResult} from "../../utils";
import {connect} from "react-redux";
import {findParties, loadParty} from "../../actions/parties";
import {showModal} from "../../actions/modal";
import PropTypes from "prop-types";
import {PartyRole, PartyStatus, PartyText as t, PartyType, PartyVariant} from "../../utils/enums";
import PartyForm from "../party/PartyForm";

class PartyField extends Component {

	findPartiesTimeout = null;

	constructor(props) {
		super(props);

		this.state = {
			initialParty: null,
			partyModalOpen: null,
			partyId: null
		}
	}

	componentWillMount() {
		const {input: {value}, onOptionInfoHook} = this.props;
		if (value) {
			this.props.loadParty(value).then((json) => {
				if (resolveApiResult(json)) {
					this.setState({initialParty: json.response.data});
					if (onOptionInfoHook) {
						onOptionInfoHook(json.response.data);
					}
				} else {
					this.setState({initialParty: false});
				}
			});
		} else {
			this.setState({initialParty: false});
		}
	}

	componentWillUnmount() {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}
	}

	handlePartyModalClick(partyId) {
		this.setState({partyModalOpen: true, partyId})
	}

	handlePartyModalDismiss() {
		this.setState({partyModalOpen: false, partyId: null})
	}

	handleFindParties(search, callback, currentParty = null) {
		if (this.findPartiesTimeout) {
			clearTimeout(this.findPartiesTimeout);
		}
		this.findPartiesTimeout = setTimeout(() => {
			const f = {search};
			if (this.props.variant === PartyVariant.INTAKE_MUNI) {
				f['roles'] = [PartyRole.MUNICIPALITY];
			}
			if (this.props.variant === PartyVariant.EXIT_ORG) {
				f['partyType'] = PartyType.PO;
			}
			handleTypeheadSearch(f, createPartyOption, this.props.findParties, callback, currentParty);
		}, search ? 500 : 0);
	}

	createNewParty() {
		switch (this.props.variant) {
			case PartyVariant.INTAKE_MUNI:
				return {
					partyType: PartyType.PO,
					partyRoles: [PartyRole.MUNICIPALITY],
					status: PartyStatus.ACTIVE
				};
			case PartyVariant.EXIT_ORG:
				return {
					partyType: PartyType.PO,
					partyRoles: [],
					status: PartyStatus.ACTIVE
				};
			case PartyVariant.WALKER:
				return {
					partyType: PartyType.FO,
					partyRoles: [PartyRole.WALKER],
					status: PartyStatus.ACTIVE
				};
			case PartyVariant.INTAKE_PARTY:
			case PartyVariant.ALT_PARTY:
			default:
				return {
					partyType: PartyType.FO,
					partyRoles: [],
					status: PartyStatus.ACTIVE
				};
		}
	}

	renderPartyModal() {
		const {input, variant} = this.props;
		const {partyModalOpen, partyId} = this.state;
		if (!partyModalOpen) {
			return null;
		}

		const modal = {
			type: 'party',
			onHide: () => this.handlePartyModalDismiss(),
			onSuccess: (d) => {
				this.setState({initialParty: d}, () => {
					input.onChange(d.partyId);
					if (this.props.onOptionInfoHook) {
						this.props.loadParty(d.partyId).then((json) => {
							if (resolveApiResult(json)) {
								this.props.onOptionInfoHook(json.response.data);
							}
						});
					}
				});
			}
		}

		const party = partyId
			? {partyId}
			: this.createNewParty();

		return <PartyForm
			variant={variant}
			form={'party-' + input.name}
			party={party}
			modal={modal}/>
	}

	render() {
		const {
			input,
			sizes,
			variant,
			clearable = false,
			...props
		} = this.props;
		const {initialParty} = this.state;

		return (
			<Row>
				<Col sm={8}>
					<TypeheadField {...props}
						input={input}
						sizes={[3, 9]}
						key={JSON.stringify(initialParty)}
						clearable={clearable}
						emptyText={t[variant].emptyText}
						loadOptions={(i, c) => this.handleFindParties(i, c, initialParty)}
						searchPromptText={t[variant].search}/>
				</Col>
				<Col sm={4}>
					{input.value
						? <Button type="button" className="btn btn-info"
							onClick={() => this.handlePartyModalClick(input.value)}>
							<Glyphicon glyph="pencil"/> {t[variant].edit}</Button>
						: <Button type="button" className="btn btn-info"
							onClick={() => this.handlePartyModalClick(null)}>
							<Glyphicon glyph="plus"/> {t[variant].new}</Button>
					}
					{this.renderPartyModal()}
				</Col>
			</Row>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		enums,
		session
	} = state;

	return {
		enums,
		session
	}
}

PartyField.propTypes = {
	variant: PropTypes.string.isRequired,
	onOptionInfoHook: PropTypes.func,
	findParties: PropTypes.func.isRequired,
	loadParty: PropTypes.func.isRequired,
	showModal: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
};

export default connect(mapStateToProps, {
	findParties,
	loadParty,
	showModal
})(PartyField)



// WEBPACK FOOTER //
// ./src/components/form/PartyField.js